import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div<{ $blur?: boolean }>`
  flex: 1 1 0px;
  background: ${Colors.White};
  border-radius: 20px;
  min-height: 184px;

  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ $blur }) =>
    $blur &&
    css`
      filter: blur(10px);
      user-select: none;
    `};

  ${Media.Phone`
    height: 148px;
    padding: 16px;
    gap: 1px;
    background: ${Colors.White};
    border-radius: 20px; 

    &:nth-child(1) {
      border-radius: 20px 0px 20px 20px;
    }

    &:nth-child(2) {
      border-radius: 0px 20px 20px 20px;
    }
  `}
`

export const Title = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const Subtitle = styled.div<{ $color?: string }>`
  ${Typography.Body};
  ${FontWeights.Regular};
  padding-bottom: 10px;
  color: ${({ $color }) => $color};
  &::first-letter {
    text-transform: uppercase;
  }
`

export const Value = styled.div`
  ${Typography.L};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
`

export const ContainerCardFeedback = styled.div`
  flex: 1 1 0px;
  background: ${Colors.White};
  border-radius: 20px;
  flex-shrink: 0;
  padding: 24px;
  display: flex;
  gap: 10px;
  flex-direction: column;
`
